/**
 * 塞入一个字段，使其只读不可修改，同时 Vue 也无法将其变成 observable 字段（可提高性能）
 */
export function setConstValue(target, key, value) {
  Object.defineProperty(target, key, {
    configurable: false,
    enumerable: true,
    value
  });
}
//# sourceMappingURL=setConstValue.js.map
